export default __webpack_public_path__ + "static/projector_b.3ca97dc737e4ef7a1e7fe05c997a3964.svg";